


























































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import Alert from '@/components/Shared/Alert.vue';
import EntityType from '@/models/Shared/EntityType';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';
import { InactivityReportModule } from '@/store/modules/inactivityReport';

@Component({
    name: 'AgencyInactivityReports',
    components: { Alert },
})
export default class extends GiganautVue {
    EntityType = EntityType;
    StatusDisplayLocation = StatusDisplayLocation;

    activeTab = 0;
    lookbackDays = 30;
    branchId = '';
    deskId = '';
    includeNever = false;

    headers = [
        { text: 'Name', value: 'name' },
        { text: 'Linked', value: 'secondaryLabel' },
        { text: 'Last activity', value: 'lastActivityAt', width: 140 },
        { text: 'Days since', value: 'daysSinceActivity', width: 110 },
        { text: 'Last owner', value: 'lastActivityOwner', width: 180 },
        { text: '', value: 'actions', sortable: false, width: 60 },
    ];

    get loading() { return InactivityReportModule.loading; }
    get response() { return InactivityReportModule.response; }
    get rows() { return this.response ? this.response.items : []; }

    get entityType(): EntityType {
        return InactivityReportModule.request.entityType;
    }

    get entityName(): string {
        switch (this.entityType) {
            case EntityType.Company: return 'companies';
            case EntityType.Location: return 'locations';
            case EntityType.Contact: return 'contacts';
            default: return 'entities';
        }
    }

    setEntityType(type: EntityType) {
        InactivityReportModule.patchRequest({ entityType: type });
    }

    onFilterChange() {
        // Defer running until the user hits Run.
    }

    @Watch('lookbackDays') onLookbackChanged(v: number) {
        InactivityReportModule.patchRequest({ lookbackDays: v });
    }
    @Watch('includeNever') onIncludeNeverChanged(v: boolean) {
        InactivityReportModule.patchRequest({ includeNever: v });
    }

    async onRun() {
        InactivityReportModule.patchRequest({
            lookbackDays: this.lookbackDays,
            branchId: this.branchId || null,
            deskId: this.deskId || null,
            includeNever: this.includeNever,
        });
        await InactivityReportModule.run();
    }

    navigateToEntity(id: string) {
        let path = '';
        switch (this.entityType) {
            case EntityType.Company: path = '/agency/companies/'; break;
            case EntityType.Location: path = '/agency/locations/'; break;
            case EntityType.Contact: path = '/agency/contacts/'; break;
            default: return;
        }
        this.$router.push(path + id);
    }

    formatDate(s: string | null | undefined): string {
        if (!s) return '-';
        return new Date(s).toLocaleString();
    }
}
